import React from 'react';
import PropTypes from 'prop-types';

export default function RoadsIcon({ color = '#ffffff', width = 20, height = 20 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={width} height={height} fill={color}>
      <path d="M239.5 99.1H160.1c-10.1 0-18.8 7.1-20.9 16.9L83.8 379.6c-2.8 13.3 7.3 25.7 20.9 25.7H239.5V357h32.2v48.4H406.7c13.6 0 23.7-12.5 20.9-25.7L372 116c-2.1-9.9-10.8-16.9-20.9-16.9H271.8v32.2H239.5V99.1zm32.2 161.2v64.5H239.5V260.3h32.2zm-32.2-96.7h32.2V228H239.5V163.6z" />
    </svg>
  );
}

RoadsIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
